import { render, staticRenderFns } from "./CardGateway.vue?vue&type=template&id=5a6f1630&"
import script from "./CardGateway.vue?vue&type=script&lang=ts&"
export * from "./CardGateway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports